import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import type { PopupState as PopupStateProps } from 'material-ui-popup-state/hooks';
import { Breadcrumb } from '@/components/presentation/Breadcrumbs';
import { WorkspacesContextMenuPopper } from '@/components/Workspace/WorkspacesMenu';
import * as consts from '@/consts';
import type { Workspace } from '@/types';
import { cx } from '@trinity/chat-components';
import styles from './style/Breadcrumbs.module.css';

type Props = {
  workspace: Pick<Workspace, 'name'>;
};

export const WorkspaceBreadcrumb = ({ workspace }: Props) => {
  const renderAnchor = useCallback((state: PopupStateProps) => {
    const className = cx({
      [styles.open]: state.isOpen,
    });

    const name = workspace.name.startsWith('Group ') || workspace.name.startsWith('Account ')
      ? 'Workspace'
      : workspace.name;

    console.log('workspace.name:', workspace.name);

    return (
      <Breadcrumb className={className}>
        {name}
      </Breadcrumb>
    );
  }, [workspace]);

  return (
    <WorkspacesContextMenuPopper
      renderAnchor={renderAnchor} />
  );
};

export const HomeBreadcrumb = () => {
  return (
    <Link to={consts.path.Home}>
      <Breadcrumb>
        Home
      </Breadcrumb>
    </Link>
  );
};

export const SharedBreadcrumb = () => {
  const renderAnchor = useCallback((state: PopupStateProps) => {
    const className = cx({
      [styles.open]: state.isOpen,
    });

    return (
      <Breadcrumb className={className}>
        Shared
      </Breadcrumb>
    );
  }, []);

  return (
    <WorkspacesContextMenuPopper
      renderAnchor={renderAnchor} />
  );
};